export default __webpack_public_path__ + "static/User1-20a68fe6787400c49967c750e335ae1b.png";